import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 28,
    type: CHECKLIST_ITEM_TYPE.STAFF_PICKER,
    manifestKey: 'STAFF_PICKER',

    try_it: {
        button_label: 'Pick Staff Member',
        // Structured-data types fall through to ConfirmationCell (default) in the switch — no dedicated cell exists yet.
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'ConfirmationCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { staff_user_id: 42 },
        },
    },
    pre_flight_diff: [
        '⚠ value will NOT persist — known bug (BE-#273-cleanup)',
        'PATCH /checklist/{iid}/ with value="<practice_user_id>" → 200 but value silently dropped',
        '⚠ Cross-tenant security risk: any integer accepted in response_payload.staff_user_id — no practice scoping on BE',
        'Checklist item: PENDING → YES (via complete POST only)',
        'Staff member ID can be stored in response_payload on complete POST (workaround, but not validated)',
    ],
    has_step2_throttle: false,
    validation_laboratory: [
        {
            label: 'PATCH value="42" (silent-drop)',
            body: { value: '42' },
            expected: '200 but value not persisted (silent drop) — GET confirms field absent',
        },
        {
            label: 'POST staff_user_id from another practice',
            body: {
                completion_state: 'YES',
                response_payload: { staff_user_id: 99999 },
            },
            expected: '200 accepted — no cross-tenant PracticeUser ID validation on BE (security gap)',
        },
    ],
};
